// @ts-nocheck
import {
    chain,
    SetUpProductInfos as baseSetUpProductInfos,
} from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { createFromProduct } from "@store/Modules/client-framework/src/Common/ProductInfo";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const SetUpProductInfos = createChainHandler("SetUpProductInfos", chain, props => {
    // Only the "createFromProduct" function import has changed.
    if (!props.products) {
        return;
    }

    props.productInfos = [];
    for (const product of props.products) {
        props.productInfos.push(createFromProduct(product));
    }
});

replaceInChain(chain, baseSetUpProductInfos, SetUpProductInfos);
